<template>
  <div
    v-if="loaded && $store.state.auth.status.loggedIn"
    class="wrapper"
  >
    <div class="row">
      <div class="col">
        <h1 class="welcome text-center mt-3 font-custom">
          {{ $t('title.home.welcome') }} {{ user.login }} !
        </h1>
      </div>
    </div>
    <div class="container">
      <p>{{ $t('login.footer') }} {{ version }}</p>
    </div>
  </div>
  <div
    v-else-if="errorMessage"
    class="alert alert-warning text-center border-0 shadow-sm rounded-0"
  >
    {{ $t('error.' + errorMessage) }}
  </div>
</template>

<script src="./HomeComponent.js"></script>

<style src="./HomeComponent.scss" scoped lang="scss"></style>
